import { render, staticRenderFns } from "./MapPin.vue?vue&type=template&id=38c9236d&"
import script from "./MapPin.vue?vue&type=script&lang=js&"
export * from "./MapPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports